export default __webpack_public_path__ + "static/media/ukrainego-screenshot-04.f3e682a2.png";